export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7211.779f4b50.jpg";